<template>
  <div class="wrapper">
    <div id="app">
      <Menu />
      <Header />      
      <router-view />
      <Divider />
      <Map />
      <Divider />
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Map from "@/components/Map";
import Divider from "@/components/Divider";
import Menu from "@/components/Menu";

export default {
    name: "App",
    components: {
        Header,
        Map,
        Footer,
        Divider,
        Menu
    }
};
</script>

<style lang="scss">

  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #7DD2D9;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #009090;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #007c7c;
  }
@import "assets/font-awesome-4.7.0/css/font-awesome.min.css";
@import "assets/css/master-postgrado/bootstrap.min.css";
@import "assets/css/master-postgrado/main.css";
@import "assets/css/stlProyecto.css";
</style>